import { Button, List, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { ChevronUp, ChevronDown, ChevronRight, Plus, File } from "lucide-react";
import React from "react";
import { FileAdder } from "./FileAdder";
import DeviceMenu from "./DeviceMenu";

const collator =
  typeof Intl !== "undefined" && Intl.Collator
    ? new Intl.Collator(undefined, { numeric: true, sensitivity: "base" })
    : { compare: (a, b) => a.localeCompare(b) };

const MultiFile = ({ file }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton onClick={() => setOpen((x) => !x)}>
          <ListItemText
            primary={file.description ?? file.originalFilenames?.[file.filename.split(",")[0]] ?? "Keine Beschreibung"}
            secondary={dayjs.utc(file.createdAt, "YYYY-MM-DD HH:mm:ss").local().format("ddd, DD.MM.YYYY HH:mm") + " Uhr"}
          />
          {open ? <ChevronUp /> : <ChevronDown />}
        </ListItemButton>
      </ListItem>

      {open
        ? file.filename.split(",").map((fn, i, x) => (
            <ListItem disablePadding key={fn}>
              <ListItemButton onClick={() => window.open(import.meta.env.VITE_APP_URL + "/image/" + fn, "_blank")}>
                <ListItemText primary={`Datei ${i + 1} von ${x.length}`} />
                <ChevronRight />
              </ListItemButton>
            </ListItem>
          ))
        : null}
    </>
  );
};

export function DocumentsPart({ title, parentKey, image, setVisiblePage, parentId, allowCreation, invalidationId, files }) {
  const visibleFiles = files.filter((x) => !x.deleted);

  return (
    <>
      <DeviceMenu
        type={"DOCS"}
        image={image}
        setType={setVisiblePage}
        plusButton={
          allowCreation ? (
            <FileAdder
              disabled={false}
              Opener={({ onPress }) => (
                <Button
                  onClick={onPress}
                  variant="contained"
                  size="small"
                  sx={{
                    minWidth: 0,
                    bgcolor: "common.white",
                    color: "common.black",
                    border: "1px solid",
                    borderColor: "grey.300",
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "grey.100",
                      boxShadow: "none",
                      borderColor: "grey.400",
                    },
                  }}
                >
                  <Plus />
                </Button>
              )}
              parentKey={parentKey}
              parentId={parentId}
              invalidationId={invalidationId}
            />
          ) : undefined
        }
      />

      <List
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
          p: 0,
        }}
      >
        {visibleFiles.length === 0 ? (
          <Typography variant="body2" color="text.secondary" align="center" sx={{ p: 2 }}>
            Hier ist noch nichts.
          </Typography>
        ) : null}

        {visibleFiles
          .sort((a, b) => collator.compare(a.category, b.category) || (a.description ?? "").localeCompare(b.description ?? ""))
          .flatMap((pos, i, sll) =>
            [
              i === 0 || pos.category !== sll[i - 1].category ? (
                <ListItem key={"title" + pos.id} sx={{ backgroundColor: "#eee" }}>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        sx={{
                          textTransform: "uppercase",
                          color: "text.secondary",
                        }}
                      >
                        {pos.category || "Ohne Kategorie"}
                      </Typography>
                    }
                  />
                </ListItem>
              ) : null,
              pos.filename.includes(",") ? (
                <MultiFile file={pos} key={"element" + pos.id} />
              ) : (
                <ListItem disablePadding key={"element" + pos.id}>
                  <ListItemButton onClick={() => window.open(import.meta.env.VITE_APP_URL + "/image/" + pos.filename, "_blank")}>
                    <ListItemText
                      primary={pos.description || pos.originalFilenames?.[pos.filename] || "Keine Beschreibung"}
                      secondary={dayjs.utc(pos.createdAt, "YYYY-MM-DD HH:mm:ss").local().format("ddd, DD.MM.YYYY HH:mm") + " Uhr"}
                    />
                    <ChevronRight />
                  </ListItemButton>
                </ListItem>
              ),
            ].filter(Boolean),
          )}
      </List>
    </>
  );
}
